import uuidv4 from 'uuid/v4';
import uuidv5 from 'uuid/v5';

export default function uuidGenerator() {
  const random = (Math.floor(Math.random() + 90000000) + 10000000).toString();
  const ns = uuidv5(random, uuidv5.URL);
  const uuid = uuidv5(uuidv4(), ns);
  return uuid;
}



// WEBPACK FOOTER //
// ./src/services/uuid.js